import * as React from 'react';
import { Container, TituloSecao } from './styles';
import Grid from '../../componentes/Grid';
import { useParams } from 'react-router-dom';
import userContext from '../../Context/UserContext';
import { useContext } from 'react';

const Grupo: React.FC = () => {
  const { id, name, filtro }: any = useParams();
  const currentlyUser = useContext(userContext);
  const { Codcliente, Codempresacli } = currentlyUser.user;

  return (
    <Container>
      <TituloSecao>
        Grupo {id} - {decodeURIComponent(name)}
      </TituloSecao>
      {filtro == "maisvendidos" ?
        <Grid Titulo={"Grupo" + decodeURIComponent(name)} MaisVendidos={1} Grupo={id} Codcliente={Codcliente} Codempresacli={Codempresacli} /> :
        filtro == "lancamentos" ?
          <Grid Titulo={"Grupo" + decodeURIComponent(name)} Lancamento={1} Grupo={id} Codcliente={Codcliente} Codempresacli={Codempresacli} /> :
          <Grid Titulo={"Grupo" + decodeURIComponent(name)} Grupo={id} Codcliente={Codcliente} Codempresacli={Codempresacli} />
      }

    </Container>
  )
};

export default Grupo;
